import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core'

/**
 * リアルタイム音声波形をバーグラフで描画するコンポーネント
 */
@Component({
  selector: 'app-audio-waveform',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '<canvas #canvas width="300" height="100"></canvas>',
})
export class AudioWaveformComponent implements OnDestroy {
  @ViewChild('canvas', { static: true })
  canvasRef!: ElementRef<HTMLCanvasElement>

  private audioContext: AudioContext | null = null
  private analyserNode: AnalyserNode | null = null
  private sourceNode: MediaStreamAudioSourceNode | null = null
  private animationFrameId: number | null = null

  @Input()
  set mediaStream(stream: MediaStream | null) {
    this.cleanup()
    if (!stream) return

    this.audioContext = new AudioContext()
    this.analyserNode = this.audioContext.createAnalyser()
    this.analyserNode.fftSize = 256
    this.analyserNode.smoothingTimeConstant = 0.8

    this.sourceNode = this.audioContext.createMediaStreamSource(stream)
    this.sourceNode.connect(this.analyserNode)

    this.draw()
  }

  ngOnDestroy(): void {
    this.cleanup()
  }

  /** 描画ループ */
  private draw(): void {
    if (!this.analyserNode || !this.canvasRef) return

    const canvas = this.canvasRef.nativeElement
    const ctx = canvas.getContext('2d')
    if (!ctx) return

    const bufferLength = this.analyserNode.frequencyBinCount
    const dataArray = new Uint8Array(bufferLength)
    this.analyserNode.getByteFrequencyData(dataArray)

    const width = canvas.width
    const height = canvas.height

    ctx.clearRect(0, 0, width, height)

    const barWidth = width / bufferLength
    ctx.fillStyle = '#00ff88'

    for (let i = 0; i < bufferLength; i++) {
      const barHeight = (dataArray[i] / 255) * height
      const x = i * barWidth
      const y = height - barHeight
      ctx.fillRect(x, y, barWidth - 1, barHeight)
    }

    this.animationFrameId = requestAnimationFrame(() => this.draw())
  }

  /** リソースを解放する */
  private cleanup(): void {
    if (this.animationFrameId != null) {
      cancelAnimationFrame(this.animationFrameId)
      this.animationFrameId = null
    }

    if (this.sourceNode) {
      this.sourceNode.disconnect()
      this.sourceNode = null
    }

    if (this.audioContext) {
      this.audioContext.close()
      this.audioContext = null
    }

    this.analyserNode = null
  }
}
